import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
 interface CertificatesFormProps {
    apmcName: string;
    districtName: string;
    check:any;
    issued?:boolean;
    setCheck:any;
    certificateData:any
    setCertificateData:any
 }
export const Certificates1 = ({
apmcName,districtName,check,setCheck,issued,certificateData,setCertificateData
}: CertificatesFormProps) =>{
  
 
  return (
   
   
  <div className="card" style={{ marginTop: '40px' }}>
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
            Proposal for permission for buying land (જમીન ખરીદવાની પરવાનગી માટે દરખાસ્ત) - પ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
             <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ, એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો
ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં. ના અધિકૃત કરાયેલ પ્રતિનિધિ શ્રી
              <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              દ્વારા સ્થળ તપાસ
કરવામાં આવેલ છે. રજૂ રેકર્ડ અને સ્થળ તપાસ અહેવાલના આધારે મારો સ્પષ્ટ અભિપ્રાય થાય છે કે બજાર
સમિતિએ જમીન ખરીદી કરવા અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
            </p>
            <p>
              (The details filled in all the columns of the proposal submitted by the Agricultural Produce Market Committee have been verified and found to be correct.
The proposal of the said Market Committee has been inspected on-site by the authorized representative Shri
              <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              . of the Deputy Director, Agricultural Market and Rural Economy and the District Registrar, Co-operative Societies.
Based on the submitted records and the site inspection report, it is my clear opinion that the approval sought by the Market Committee for land purchase is found to be appropriate/inappropriate.)
            </p>
          </div>
        </div>
      </div>
 
  );
};

 
export const Certificates2 = ({
apmcName,districtName,check,setCheck,issued,certificateData,setCertificateData
}: CertificatesFormProps) => {


 
  return (
   
    
      <div className="card">
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
            Proposal for permission for selling નિયંત્રિત જણસી જાહેર કરવા બાબત
(To control Agriculture products under the APMC - Application under Form-8)
landપ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
           <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                 <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
                <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              ના અધિકૃત કરાયેલ પ્રતિનિધિ શ્રી
              <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
                હોદ્દો
          <input
                type="text"
                value={certificateData.positionName}
                onChange={(e) =>setCertificateData({...certificateData, positionName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
                દ્વારા સ્થળ તપાસ કરવામાં આવેલ છે.રજૂ રેકર્ડ અને સ્થળ તપાસ અહેવાલના આધારે મારો સ્પષ્ટ અભિપ્રાય થાય છે કે બજાર સમિતિએ જમીન વેચાણ કરવા અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
            </p>
            <p>
              (The Agricultural Produce Market Committee,
              <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              has verified the details filled in all columns of the submitted proposal and found them to be correct. The said proposal of the Market Committee has been inspected by the authorized representative Shri
              <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              Designation
                  <input
                type="text"
                value={certificateData.positionName}
                onChange={(e) =>setCertificateData({...certificateData, positionName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              of the office of the Deputy Director, Agricultural Market and Rural Economy and District Registrar, Co-operative Societies,
              <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              Based on the submitted records and the site inspection report, it is my clear opinion that the approval sought by the Market Committee for the sale of land appears to be appropriate/inappropriate.
              )
            </p>
          </div>
        </div>
      </div>
    
  );
};
export const Certificates3 = ({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps) => {
  
 
  return (
   
 
      <div className="card">
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
           નિયંત્રિત જણસી જાહેર કરવા બાબત 
(To control Agriculture products under the APMC - Application under Form-8)
landપ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
              <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
             એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
               <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              દ્વારા તપાસેલ છે. અને મારો સ્પષ્ટ અભિપ્રાય થાય છે કે બજાર સમિતિએ જણસી નિયંત્રિત કરવા અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય /અયોગ્ય જણાય છે.
            </p>
            <p>
              (The Agricultural Produce Market Committee,
              <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              has been verified for all the details filled in the proposal columns, and they have been found to be correct. The said proposal of the Market Committee has been examined by the Deputy Director, Agricultural Market and Rural Economy, and the District Registrar, Co-op. Societies,
            <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                . Based on this, it is my clear opinion that the approval sought by the Market Committee to regulate the commodity appears to be appropriate/inappropriate.)
            </p>
          </div>
 
        </div>
      </div>
   
  );
};
export const Certificates4 = ({
apmcName,districtName,check,setCheck,issued,certificateData,setCertificateData
}: CertificatesFormProps) => {
 
 
  return (
   
   
      <div className="card">
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
            બજાર સમિતિના મુખ્ય યાર્ડ / સબયાર્ડ જાહેર કરવા બાબત.
(Declaration of the main yard/sub-yard of APMC) - પ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
               <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
             <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
             એ  કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
              <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              ના અધિકૃત કરાયેલ પ્રતિનિધિ શ્રી
             <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              હોદ્દો
             <input
                type="text"
                value={certificateData.positionName}
                onChange={(e) =>setCertificateData({...certificateData, positionName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              દ્વારા સ્થળ તપાસ કરવામાં આવેલ છે. રજૂ રેકર્ડ અને સ્થળ તપાસ અહેવાલના આધારે મારો સ્પષ્ટ અભિપ્રાય થાય છે કે બજાર સમિતિએ મુખ્યયાર્ડ / સબયાર્ડ જાહેર કરવા અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
            </p>
            <p>
              (The Agricultural Produce Market Committee,
              <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              has been verified for all the details filled in the columns of the submitted proposal, and they have been found to be correct. The said proposal of the Market Committee has been examined by the Deputy Director, Agricultural Market and Rural Economy, and the District Registrar, Co-op. Societies,
           <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                , through the authorized representative Mr.
             <input
                type="text"
                value={certificateData.FilledFormName}
                onChange={(e) =>setCertificateData({...certificateData, FilledFormName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              holding the position of
               <input
                type="text"
                value={certificateData.positionName}
                onChange={(e) =>setCertificateData({...certificateData, positionName: e.target.value})}
                className="mx-1 border-0 border-bottom border-secondary mb-3"
                readOnly={issued? true : false}
              />
              by conducting a site inspection. Based on the submitted records and the site inspection report, it is my clear opinion that the permission sought by the Market Committee for declaring the main yard / sub-yard appears to be appropriate/inappropriate)
            </p>
          </div>
        </div>
      </div>
   
  );
};
export const Certificates5 = ({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps) => {
  
 
  return (
   
   
      <div className="card">
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
            બજાર સમિતિમાં સેક્રેટરીની નવીન / હંગામી નિમણૂક બાબત (Matter regarding the new/permanent or
temporary appointment of the Secretary in the Market Committee) - પ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
             <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              એ કરેલ દરખાસ ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
               <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
             એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
              <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના સેક્રેટરીની નિમણૂક અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
             
            </p>
            <p>
              (The proposal made by the Agricultural Produce Market Committee,
               <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
               has been verified for all the details filled in each column and found to be correct. The said proposal of the Market Committee has been examined by the office of the Deputy Director, Agricultural Market and Rural Economy, and the District Registrar, Co-op. Societies
               <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                Based on this, the approval sought regarding the appointment of the Secretary of the Market Committee appears to be appropriate/inappropriate.)
            </p>
          </div>
        </div>
      </div>

  );
};
export const Certificates6 = ({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps) => {
  
 
  return (
   
   
            <div className="card">
        <div className="card-header  text-white">
          <h4 className="mb-0 text-center">
            બજાર સમિતિમાં સેક્રેટરીની કાયમી નિમણૂક બાબત
(Permanent appointment of Secretary in the Market Committee) - પ્રમાણપત્ર(Certificate)
          </h4>
        </div>
        <div className="card-body d-flex">
             <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
            <p className="mb-2">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
            <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
             એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
                  <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના સેક્રેટરીની નિમણૂક અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
             
            </p>
            <p>
              (All the details filled in the columns of the proposal submitted by the Agricultural Produce Market Committee,
              <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
               have been verified and found to be correct. The proposal of the said Market Committee has been examined by the office of the Deputy Director, Agricultural Market and Rural Economy, and the District Registrar, Co-operative Societies,
             <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
              The approval sought regarding the appointment of the Secretary of the Market Committee appears to be appropriate/inappropriate.)
            </p>
          </div>
        </div>
      </div>
   
  );
};
 export const Certificate7 =({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps) => {
 

  return (

    <div>
      
      
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              બજાર સમિતિના સ્ટાફ શિડ્યુલમાં સુધારા બાબત (Regarding amendment in
              the staff schedule of the Market Committee) -
              પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
              <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,{" "}
                <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં.
               <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                -ની કચેરી દ્વારા ચકાસણી થયેલ છે. બજાર સમિતિના સ્ટાફ શિડયુલ
                અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય છે.
              </p>
              <p>
                (Agricultural Produce Market Committee,
                <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                has verified all the details filled in the proposal and found
                them to be correct. The said proposal of the Market Committee
                has been verified by the office of the Deputy Director,
                Agricultural Market and Rural Economy, and the District
                Registrar, Co-operative Societies,
               <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                . The approval sought regarding the staff schedule of the Market
                Committee is found to be appropriate/inappropriate.)
              </p>
            </div>
          </div>
        </div>
      </div>

  );
};



export const Certificate8=({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps)=>{
     

  return(
      
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              બજાર સમિતિમાં આસીસ્ટન્ટ સેક્રેટરી / ઈન્સપેકટરમાંથી સેક્રેટરીમાં
              બઢતી બાબત (Regarding promotion from Assistant Secretary /
              Inspector to Secretary in the Market Committee)- પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
               <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
               <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં.
              <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                ની કચેરી દ્વારા ચકાસણી થયેલ છે. બજાર સમિતિના સેક્રેટરીની બઢતીથી
                નિમણૂક અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય
              </p>
              <p>
                (The details filled in all the columns of the proposal made by
                the Agricultural Produce Market Committee,
                 <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                have been verified and found to be correct. The said proposal of
                the Market Committee has been examined by the office of the
                Deputy Director, Agricultural Market and Rural Economy, and the
                District Registrar, Co-operative Societies,
                 <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                The approval sought for the appointment of the Secretary of the
                Market Committee through promotion appears to be
                appropriate/inappropriate.) 
              </p>
            </div>
          </div>
        </div>
     
  );
}
export const Certificate9=({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps)=>{


  return( 
      
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              નિવૃત્તિ બાદ સેક્રેટરી / કર્મચારીની કરાર આધારિત નિમણૂક બાબત
              (Regarding contractual appointment of Secretary / employee after
              retirement)- પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
            <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                  <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં.
                 <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના સેક્રેટરી /
                કર્મચારીની કરાર આધારિત નિમણૂક અંગેની જે મંજૂરી માંગેલ છે, તે
                યોગ્ય / અયોગ્ય જણાય છે.
              </p>
              <p>
                (The details filled in all columns of the proposal submitted by
                the Agricultural Produce Market Committee,
                  <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                have been verified and found to be correct. The said proposal of
                the Market Committee has been examined by the office of the
                Deputy Director, Agricultural Market and Rural Economy and the
                District Registrar, Co-operative Societies,
                <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                The approval sought regarding the contractual appointment of the
                Secretary / employee of the Market Committee appears to be
                appropriate / inappropriate.)
              </p>
            </div>
          </div>
        </div>
      
  );

}
export const Certificate10=({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps)=>{
  

  return( 
     
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              સેક્રેટરી / કર્મચારીના સાતમા પગાર પંચ મંજૂરી બાબત (Regarding
              approval of 7th Pay Commission for Secretary / employee)- પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
             <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                   <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
                 <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                ની કચેરી દ્વારા ચકાસણી થયેલ છે. બજાર સમિતિના સેક્રેટરીની નિમણૂક
                અંગેની જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
              </p>
              <p>
                (The details filled in all the columns of the proposal submitted
                by the Agricultural Produce Market Committee,{" "}
                 <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                , have been verified and found to be correct. The said proposal
                of the Market Committee has been examined by the office of the
                Deputy Director, Agricultural Marketing and Rural Economy and
                the District Registrar, Co-operative Societies,
               <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                The approval sought regarding the appointment of the Secretary
                of the Market Committee appears to be appropriate /
                inappropriate.) Raise Query: Sent Back to Junior clerk Forward
                to JC to HO
              </p>
            </div>
          </div>
        </div>
      
  );

}
export const Certificate11= ({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps) =>{
   

  return( 
    <div className="card">
      <div className="card-header  text-white">
        <h4 className="mb-0 text-center">
          બજાર સમિતિ દ્વારા દાન આપવા બાબત ( Applications for Proposals
          regarding donation )- પ્રમાણપત્ર(Certificate)
        </h4>
      </div>
      <div className="card-body d-flex">
        <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
          <p className="mb-2">
            ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
            <input
              type="text"
              value={apmcName}
              className="border-0 border-bottom border-secondary mb-3"
              style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
              readOnly
            />
            એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
            જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
            ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
            <input
              type="text"
              value={districtName}
              className="border-0 border-bottom border-secondary mb-3"
              style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
              readOnly
            />
            ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના દાન અંગેની જે મંજૂરી
            માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
          </p>
          <p>
            (The details filled in all the columns of the proposal submitted
            by the Agricultural Produce Market Committee,
            <input
              type="text"
              value={apmcName}
              className="border-0 border-bottom border-secondary mb-3"
              style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
              readOnly
            />
            have been verified and found to be correct. The proposal of the
            said Market Committee has been examined by the office of the
            Deputy Director, Agricultural Market and Rural Economy and the
            District Registrar, Co-op. Societies,
            <input
              type="text"
              value={districtName}
              className="border-0 border-bottom border-secondary mb-3"
              style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
              readOnly
            />
            The approval sought by the Market Committee regarding the
            donation appears to be appropriate / inappropriate.)
          </p>
        </div>
      </div>
    </div>
  );

}
export const Certificate12=({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps)=>{
 

  return( 
     
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              બજાર સમિતિ દ્વારા લોન લેવા બાબત (Applications for Proposals
              regarding loan)- પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
                <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
               <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં.{" "}
                  <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના લોન લેવા અંગેની જે
                મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
              </p>
              <p>
                (The details filled in all columns of the proposal submitted by
                the Agricultural Produce Market Committee,{" "}
               <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                have been verified and found to be correct. The said proposal of
                the Market Committee has been examined by the office of the
                Deputy Director, Agricultural Market and Rural Economy, and the
                District Registrar, M.C.{" "}
                 <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />{" "}
                The approval sought by the Market Committee regarding obtaining
                the loan is found to be appropriate/inappropriate.)
              </p>
            </div>
          </div>
        </div>
     
  );

}
export const Certificate13=({
apmcName,districtName,check,setCheck,issued
}: CertificatesFormProps)=>{


  return( 
      
        <div className="card">
          <div className="card-header  text-white">
            <h4 className="mb-0 text-center">
              બજાર સમિતિના અભ્યાસ પ્રવાસ બાબત (Approval for Study Tours -
              Application)- પ્રમાણપત્ર(Certificate)
            </h4>
          </div>
          <div className="card-body d-flex">
             <div className="form-check mb-2">
          {issued ? null : (
            <input
              type="checkbox"
              className="form-check-input"
              id="verifyCheck"
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          )}
        </div>
        <div>
          {issued && (
            <div className="mb-2">
              <span className="text-success fw-bold">✅ Certificate Issued by District Registrar</span>
            </div>
          )}
              <p className="mb-2">
                ખેતીવાડી ઉત્પન્ન બજાર સમિતિ,
                <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                એ કરેલ દરખાસ્તના તમામ કોલમોમાં ભરેલ વિગતો ચકાસેલ છે અને તે ખરી
                જણાયેલ છે. સદર બજાર સમિતિની દરખાસ્ત નાયબ નિયામક, ખેત બજાર અને
                ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં
                  <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                ની કચેરી દ્વારા ચકાસણી થયેલ છે.બજાર સમિતિના અભ્યાસ પ્રવાસ અંગેની
                જે મંજૂરી માંગેલ છે, તે યોગ્ય / અયોગ્ય જણાય છે.
              </p>
              <p>
                (Details filled in all columns of the proposal submitted by the
                Agricultural Produce Market Committee,
                  <input
                type="text"
                value={apmcName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${apmcName?.length > 0 ? apmcName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />{" "}
                have been verified and found correct. The proposal of the said
                Market Committee has been verified by the office of the Deputy
                Director, Agricultural Marketing and Rural Economy and District
                Registrar, Co-op. Societies,
                 <input
                type="text"
                value={districtName}
                  className="border-0 border-bottom border-secondary mb-3"
                  style={{ width: `${districtName?.length > 0 ? districtName.length : 1}ch`, minWidth: '40px', maxWidth: '100%' }}
                  readOnly
              />
                The approval sought by the Market Committee regarding the study
                tour is found to be appropriate / inappropriate.)
              </p>
            </div>
          </div>
        </div>
     
  );

}